import { render } from "./EditShip.vue?vue&type=template&id=694bf0a0&scoped=true"
import script from "./EditShip.vue?vue&type=script&lang=js"
export * from "./EditShip.vue?vue&type=script&lang=js"

import "./EditShip.vue?vue&type=style&index=0&id=694bf0a0&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694bf0a0"]])

export default __exports__